import React from 'react'
import "pages/Styles/TransactionItem.sass"

interface TransactionItemData {
    title: string
    subtitle?: string
    amount: number
    isMain?: boolean
}

interface TransactionItemProps {
    item: TransactionItemData
}

const TransactionItem: React.FC<TransactionItemProps> = ({ item }) => {
    return (
        <div className={`transaction-item ${item.isMain ? 'transaction-item--main' : ''}`}>
            <div className="transaction-item-content">
                <div className="transaction-item-title">
                    {item.title}
                </div>
                {item.subtitle && (
                    <div className="transaction-item-subtitle">
                        {item.subtitle}
                    </div>
                )}
            </div>
            <div className="transaction-item-amount">
                {formatAmount(item.amount)}
            </div>
        </div>
    )
}

function formatAmount(amount: number): string {
    return new Intl.NumberFormat('ru-RU', {
        style: 'currency',
        currency: 'RUB',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(amount / 100)
}

export default TransactionItem
export type { TransactionItemData }
